import { Provider } from "@lib/types";
import { Customer } from "@lib/types/Customer";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CacheState {
  selectedCustomer: Customer | null;
  selectedPaymentProvider: Provider | null;
  dateBetween: [string, string];
  dateBetweenTimestamp: number | null;
}

const initialState: CacheState = {
  selectedCustomer: null,
  selectedPaymentProvider: null,
  dateBetween: ["", ""],
  dateBetweenTimestamp: null,
};

const cacheSlice = createSlice({
  name: "cache",
  initialState,
  reducers: {
    setSelectedCustomer: (state, action?: PayloadAction<Customer>) => {
      state.selectedCustomer = action.payload || null;
    },
    setSelectedPaymentProvider: (state, action?: PayloadAction<Provider>) => {
      state.selectedPaymentProvider = action.payload || null;
    },
    setDateBetween: (state, action?: PayloadAction<[string, string]>) => {
      state.dateBetween = action.payload || ["", ""];
      state.dateBetweenTimestamp = action.payload ? Date.now() : null;
    },
  },
});

export const {
  setSelectedCustomer,
  setSelectedPaymentProvider,
  setDateBetween,
} = cacheSlice.actions;
export default cacheSlice.reducer;
